module.exports = __webpack_public_path__ + "img/phone-anim.b230e58.png";